// @flow

import { combineReducers } from 'redux-immutable';

import empresas from './empresas';
import certificados_digitais from './certificados_digitais';
import contas from './contas';
import politica_senha from './politica_senha';

export default combineReducers({ empresas, certificados_digitais, contas, politica_senha });